import { autoinject, transient } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import { BaseHistoryTrail } from "../../../common/base-history-trail";
import { RolePermissionAuditParameterModel } from "../../../../../models/manage/permissions.models";
import { I18N } from "aurelia-i18n";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@autoinject
@transient()
export class PermissionsAuditDialog extends BaseHistoryTrail<RolePermissionAuditParameterModel> {

    auditDateTimeFormat: string;
    public audits: any[] = [];

    constructor(private dialogClient: DialogClientService, private queriesClientService: QueriesClientService,
        notificationClientService: NotificationClientService, i18N: I18N, protected configService: ConfigService) {
        super(configService, notificationClientService, i18N);
        this.auditDateTimeFormat = this.configService.config.common.defaultDateTimeFormat
    }

    protected onActivated() {
        this.refreshData();
    }

    public refreshData() {
        //This odata url is RS specific. DO NOT REPLACE
        this.queriesClientService.getData(`/odata/RightShipAudits/Genesis.GetAudits(entityTypeId=${this.item.entityType},entityId=${this.item.id})?$orderby=timestamp desc`).then(x => {
            this.audits = x.value;
        });
    }

    close() {
        this.dialogClient.hide();
    }
}
